// extracted by mini-css-extract-plugin
export var fullWidthButton = "_nv-0";